import consts from './common/index';
export default function commonConstant(app) {
	app.constant("COMMON_CONSTS", consts);
}
